import { NgModule } from '@angular/core';
import { TranslatePipe } from './translation.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    exports: [TranslatePipe],
    declarations: [TranslatePipe]
})
export class TranslatePipeModule {
}
